
import hero from '../assets/images/hero-desktop.png';
import plugn from '../assets/images/Plugn.png';
import CarePulse from '../assets/images/CarePulse.png';
import Yo3an from '../assets/images/Yo3an.png';
import prayerTime from '../assets/images/prayer-time.png';
import weather from '../assets/images/weather.png';
import oova from '../assets/images/oova.png';
import YcDirectory from '../assets/images/ycdirectory.png';
import '../assets/styles/Project.scss';

function Project() {
    return (
        <div className="projects-container" id="projects">
            <h1>Projects</h1>
            <div className="projects-grid">
                <div className="project">
                    <a href="https://carepulse-ashen.vercel.app/" target="_blank" rel="noreferrer"><img src={CarePulse} className="zoom" alt="thumbnail" width="100%" /></a>
                    <a href="https://carepulse-ashen.vercel.app/" target="_blank" rel="noreferrer"><h2>CarePulse</h2></a>
                    <p>CarePulse is a modern solution for hospital management, designed to streamline appointment scheduling and management for both patients and administrators.</p>
                </div>
                <div className="project">
                    <a href="https://financial-dashboard-hvl6.vercel.app/" target="_blank" rel="noreferrer"><img src={hero} className="zoom" alt="thumbnail" width="100%" /></a>
                    <a href="https://financial-dashboard-hvl6.vercel.app/" target="_blank" rel="noreferrer"><h2>Acme Invoices</h2></a>
                    <p>It is a financial dashboard to manage invoices, allowing users to create, update, and delete records while tracking total balance, pending, and paid statuses. This project utilized authentication, CRUD operations, and data management techniques to ensure a seamless user experience.</p>
                </div>

                <div className="project">
                    <a href="http://saoudalturki.com/" target="_blank" rel="noreferrer"><img src={oova} className="zoom" alt="thumbnail" width="100%" /></a>
                    <a href="http://saoudalturki.com/" target="_blank" rel="noreferrer"><h2>Oova</h2></a>
                    <p>This application allows users to share videos, showcasing the latest content on a dynamic home screen. It features a visually engaging onboarding experience, robust authentication, and options to upload videos and track followers.</p>
                </div>
                <div className="project">
                    <a href="https://yc-directory-gamma-nine.vercel.app/" target="_blank" rel="noreferrer"><img src={YcDirectory} className="zoom" alt="thumbnail" width="100%" /></a>
                    <a href="https://yc-directory-gamma-nine.vercel.app/" target="_blank" rel="noreferrer"><h2>YC Directory</h2></a>
                    <p>A simple platform to share and discover startup ideas. Log in with GitHub, submit pitches with multimedia, browse by category, search ideas, and track your submissions. Features a views counter instead of upvotes, all wrapped in a clean, minimal design.</p>
                </div>
                
                
                <div className="project">
                    <a href="https://weather-app-khaki-pi.vercel.app/" target="_blank" rel="noreferrer"><img src={weather} className="zoom" alt="thumbnail" width="100%" /></a>
                    <a href="https://weather-app-khaki-pi.vercel.app/" target="_blank" rel="noreferrer"><h2>Weather</h2></a>
                    <p>This website provides weather updates by default for the user's current location and allows searching for weather in specific cities or places.
                    </p>
                </div>
                <div className="project">
                    <a href="https://prayer-time-henna.vercel.app/" target="_blank" rel="noreferrer"><img src={prayerTime} className="zoom" alt="thumbnail" width="100%" /></a>
                    <a href="https://prayer-time-henna.vercel.app/" target="_blank" rel="noreferrer"><h2>Prayer Time</h2></a>
                    <p>Displays accurate prayer times based on the user's location.</p>
                </div>
                
                
                <div className="project">
                    <a href="http://saoudalturki.com/" target="_blank" rel="noreferrer"><img src={Yo3an} className="zoom" alt="thumbnail" width="100%" /></a>
                    <a href="http://saoudalturki.com/" target="_blank" rel="noreferrer"><h2>Yo3an</h2></a>
                    <p>Food search engine helps users satisfy their cravings by finding specific dishes from nearby restaurants.</p>
                </div>

                <div className="project">
                    <a href="https://plugn.io/" target="_blank" rel="noreferrer"><img src={plugn} className="zoom" alt="thumbnail" width="100%" /></a>
                    <a href="https://plugn.io/" target="_blank" rel="noreferrer"><h2>Plugn</h2></a>
                    <p>Comprehensive e-commerce platform empowering business owners with easy online store management, seamless integration of payment gateways, and advanced marketing tools.</p>
                </div>
             

            </div>
        </div>
    );
}

export default Project;